import * as React from 'react';

import type {Tab} from '../../control-bar/page-control-bar';

import {VerticalTab} from './vertical-tab';

import styles from './vertical-tabs.module.css';

type TabProps = {
    options: Tab[];
    selectedTab: string;
    onChangeTab?: (newTab: string) => void;
};

type Props = {
    tabs: TabProps;
    getRef?: (ref?: HTMLDivElement | null | undefined) => void;
    iconOnly?: boolean;
};

/**
 * A vertical rendition of our tabs. Mimics the style of our horizontal tabs.
 *
 * Can optionally display only icon-tabs without text
 */
export function VerticalTabs(props: Props) {
    const verticalTabsContainerRef = React.useRef<HTMLDivElement | null | undefined>(null);

    const onClick = (tabId: string) => {
        if (props.tabs.onChangeTab) {
            props.tabs.onChangeTab(tabId);
        }
    };

    return (
        <div
            ref={(ref) => {
                verticalTabsContainerRef.current = ref;
                if (props.getRef) {
                    props.getRef(ref);
                }
            }}
            className={styles['vertical-tabs-container']}
        >
            {props.tabs.options
                .filter((tab) => !tab.isHidden)
                .map((tab) => {
                    const isActive = props.tabs.selectedTab === tab.id;

                    return (
                        <VerticalTab
                            key={tab.id}
                            tab={tab}
                            isActive={isActive}
                            onClick={() => onClick(tab.id)}
                            iconOnly={props.iconOnly}
                        />
                    );
                })}
        </div>
    );
}
